<template>
	<v-container grid-list-xl>
		<v-layout row wrap>					
			<v-flex lg12>
              <v-flex xs3 style="padding-left: 0px !important;">
                <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field>
              </v-flex>
				<v-data-table :headers="headers" :pagination.sync="pagination" :search="search" :items="objLinkedStatus" class="elevation-1 linkTableMediumSmall" hide-actions :rows-per-page-items="[1000]" style="font-size: 10px;">
					<template slot="items" slot-scope="props">
						<td width="10%" class="text-xs-right"><v-switch label="" v-model="props.item.linked" @click="fncSetStatusLink( props.item.id, props.item.linked )"></v-switch></td>
						<td width="90%" class="text-xs-right">{{ props.item.description }}</td>
					</template>
				</v-data-table>
			</v-flex>			
			<div class="pl-4 pr-3 pb-4 buttonHolder">
				<div style="float: right">
					<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>					
				</div>
			</div>
			<v-flex lg12 class="requiredMessage">
				&nbsp;
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
	  name: 'Settings',
	  data () {
			return {
				search: '',	
				roleActive: false,
				roleName: '',
				roleDescription: '',
				roleLevel: '',
                roleUserType: '',
                pagination: {
                  sortBy: 'priv_key'
                },
				headers: [         
					{ text: '', value: 'active', width: '10%' },
                    { text: 'DESCRIPTION', value: 'description', width: '90%' }
				]	
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');				
			},
			fncSetStatusLink(statusId, statusLink) {
				if(statusLink == true) {
					statusLink = false;
				} else {
					statusLink = true;
				}
				if(statusLink == true) {
					this.$store.dispatch({
						type: 'fncLinkRoleStatus',
						roleId: this.globalModalParams.roleId,
						statusId: statusId,
						link: true
					})
				} else {
					this.$store.dispatch({
						type: 'fncLinkRoleStatus',
						roleId: this.globalModalParams.roleId,
						statusId: statusId,
						link: false
					})
				}
			}
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'runAdd',
				'objRoleEdit',				
				'objRolePrivs',
				'globalModalParams',
				'objLinkedStatus'
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>